/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ToolPencilSquareIcon16Light } from './ToolPencilSquareIcon16Light';
import { ToolPencilSquareIcon16Regular } from './ToolPencilSquareIcon16Regular';
import { ToolPencilSquareIcon16Solid } from './ToolPencilSquareIcon16Solid';
import { ToolPencilSquareIcon20Light } from './ToolPencilSquareIcon20Light';
import { ToolPencilSquareIcon20Regular } from './ToolPencilSquareIcon20Regular';
import { ToolPencilSquareIcon20Solid } from './ToolPencilSquareIcon20Solid';
import { ToolPencilSquareIcon24Regular } from './ToolPencilSquareIcon24Regular';
import { ToolPencilSquareIcon24Solid } from './ToolPencilSquareIcon24Solid';
import { ToolPencilSquareIcon32Regular } from './ToolPencilSquareIcon32Regular';
import { ToolPencilSquareIcon64Regular } from './ToolPencilSquareIcon64Regular';
var sizes = {
    16: {
        light: ToolPencilSquareIcon16Light,
        regular: ToolPencilSquareIcon16Regular,
        solid: ToolPencilSquareIcon16Solid,
    },
    20: {
        light: ToolPencilSquareIcon20Light,
        regular: ToolPencilSquareIcon20Regular,
        solid: ToolPencilSquareIcon20Solid,
    },
    24: {
        regular: ToolPencilSquareIcon24Regular,
        solid: ToolPencilSquareIcon24Solid,
    },
    32: {
        regular: ToolPencilSquareIcon32Regular,
    },
    64: {
        regular: ToolPencilSquareIcon64Regular,
    },
};
export var ToolPencilSquareIcon = forwardRef('ToolPencilSquareIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
